<template>
  <v-container fluid>
    <v-row align="center" justify="center" v-if="!checkedUser">
      <v-col
        cols="12"
        lg="6"
        md="6"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <v-form ref="formMail" style="width: 100%">
          <v-card style="width: 100%">
            <v-card-text class="body-1">
              <v-text-field
                v-model="formUser.mail"
                filled
                dense
                :rules="[obligatoireRule()]"
                :label="$t('user.details.mail')"
                autocapitalize="none"
              />

              <v-checkbox
                :label="$t('user.details.roleCorrespondant')"
                v-model="formUser.roleCorrespondant"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="checkUser">
                {{ $t('button.confirm') }}
              </v-btn>
              <v-btn
                text
                :to="{
                  name: 'Login',
                  params: { namespaceonly: true },
                }"
              >
                {{ $t('button.cancel') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-if="checkedUser">
      <v-col
        cols="12"
        lg="6"
        md="6"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <answerQuestion
          ref="answerQuestion"
          :question="question"
          :serveurRule="serveurRule"
          @emitQuestion="emitQuestion"
          @emitResponse="emitResponse"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import toasted from '@/utils/toasted'
import AnswerQuestion from '@/view/Forgot/AnswerQuestion'
import ValidationRules from '@/plugins/mixins/ValidationRules'
import ServeurRule from '@/plugins/mixins/ServeurRule'

export default {
  mixins: [ErrorServeur, ValidationRules, ServeurRule],
  components: {
    answerQuestion: AnswerQuestion,
  },

  data() {
    return {
      formUser: {
        mail: null,
        roleCorrespondant: false,
      },
      question: {
        id: null,
        questionen: null,
        questionfr: null,
      },
      response: null,
      checkedUser: false,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    emitResponse(value) {
      this.response = value
    },

    emitQuestion() {
      this.resetPassword()
    },
    __validerMail() {
      this.resetErreur()
      if (this.$refs.formMail) {
        const ok = this.$refs.formMail.validate()
        return ok
      } else {
        return true
      }
    },

    __validerQuestion() {
      this.resetErreur()
      if (
        this.$refs.answerQuestion &&
        this.$refs.answerQuestion.$refs.formQuestion
      ) {
        return this.$refs.answerQuestion.$refs.formQuestion.validate()
      } else {
        return true
      }
    },

    getForms() {
      //access aux formulaire à créer
      if (this.checkedUser) {
        return this.$refs.answerQuestion.getForms()
      }
      if (!this.checkedUser) {
        return [this.$refs.formMail]
      }
    },
    checkUser() {
      //lance la validation
      const ok = this.__validerMail()
      if (ok) {
        this.$api('/resetPassword/user/mail', '/oauth')
          .post(
            {},
            {
              params: {
                email: this.formUser.mail,
                roleCorrespondant: this.formUser.roleCorrespondant,
              },
            },
          )
          .then((response) => {
            this.question = response.body
            this.checkedUser = true
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
    resetPassword() {
      //lance la validation
      const ok = this.__validerQuestion()
      if (ok) {
        this.$api('/resetPassword', '/oauth')
          .post({
            idQuestion: this.question.id,
            response: this.response,
            mail: this.formUser.mail,
            roleCorrespondant: this.formUser.roleCorrespondant,
          })
          .then((response) => {
            this.question = response.body
            this.checkedUser = false
            toasted.info(this.$t('forgot.confirmationMailSent'))
            this.$router.push({ name: 'Login' })
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
  },
  validations: {},
}
</script>
